export default "__VITE_ASSET__d3fcf228__"